export const images: IconType[] = [
    {
        img: 'doggy.png',
        altText: 'doggy'
    },
    {
        img: 'elephant.png',
        altText: 'elephant'
    },
    {
        img: 'bear.png',
        altText: 'bear'
    },
    {
        img: 'cow.png',
        altText: 'cow'
    },
    {
        img: 'fox.png',
        altText: 'fox'
    },
    {
        img: 'deer.png',
        altText: 'deer'
    },
    {
        img: 'slug.png',
        altText: 'slug'
    },
    {
        img: 'dude.png',
        altText: 'dude'
    },
    {
        img: 'hand.png',
        altText: 'hand'
    },
    {
        img: 'dudehandup.png',
        altText: 'dude hand up'
    },
    {
        img: 'kitty.png',
        altText: 'kitty'
    },
    {
        img: 'cloudy.png',
        altText: 'cloudy'
    },
    {
        img: 'flower.png',
        altText: 'flower'
    },
    {
        img: 'handstandguy.png',
        altText: 'handstand guy'
    },
    {
        img: 'snek.png',
        altText: 'snek'
    },
    {
        img: 'bunny.png',
        altText: 'bunny'
    },
    {
        img: 'cherry.png',
        altText: 'cherry'
    },
    {
        img: 'carrot.png',
        altText: 'carrot'
    },
    {
        img: 'beety.png',
        altText: 'beety'
    },
    {
        img: 'mushroom.png',
        altText: 'mushroom'
    },
    {
        img: 'avo.png',
        altText: 'avo'
    },
    {
        img: 'heart.png',
        altText: 'heart'
    },
    {
        img: 'moon.png',
        altText: 'moon'
    },
    {
        img: 'mountain.png',
        altText: 'mountain'
    },
    {
        img: 'star.png',
        altText: 'star'
    },
    {
        img: 'axo.png',
        altText: 'axo'
    },
    {
        img: 'tomato.png',
        altText: 'tomato'
    },
    {
        img: 'owlie.png',
        altText: 'owlie'
    },
    {
        img: 'jaguar.png',
        altText: 'jaguar'
    },
    {
        img: 'jelly.png',
        altText: 'jelly'
    },
    {
        img: 'crabby.png',
        altText: 'crabby'
    },
    {
        img: 'whale.png',
        altText: 'whale'
    },
    {
        img: 'shelly.png',
        altText: 'shelly'
    },
    {
        img: 'monkey.png',
        altText: 'monkey'
    },
    {
        img: 'goaty.png',
        altText: 'goaty'
    },
    {
        img: 'leafy.png',
        altText: 'leafy'
    },
    {
        img: 'watermelon.png',
        altText: 'watermelon'
    },
    {
        img: 'berry.png',
        altText: 'berry'
    },
    {
        img: 'w.png',
        altText: 'w'
    },
    {
        img: 'lion.png',
        altText: 'lion'
    },
    {
        img: 'raccoon.png',
        altText: 'raccoon'
    },
    {
        img: 'wiggly.png',
        altText: 'wiggly'
    },
    {
        img: 'banana.png',
        altText: 'banana'
    },
    {
        img: 'tangerine.png',
        altText: 'tangerine'
    },
    {
        img: 'olive.png',
        altText: 'olive'
    },
    {
        img: 'remi.png',
        altText: 'remi'
    },
    {
        img: 'duck.png',
        altText: 'duck'
    },
    {
        img: 'plum.png',
        altText: 'plum'
    },
    {
        img: 'flowie.png',
        altText: 'flowie'
    },
    {
        img: 'stones.png',
        altText: 'stones'
    },
    {
        img: 'rooster.png',
        altText: 'rooster'
    },
    {
        img: 'piggy.png',
        altText: 'piggy'
    },
    {
        img: 'koala.png',
        altText: 'koala'
    },
    {
        img: 'giraffe.png',
        altText: 'giraffe'
    },
    {
        img: 'hippo.png',
        altText: 'hippo'
    },
    {
        img: 'liz.png',
        altText: 'liz'
    },
    {
        img: 'mousey.png',
        altText: 'mouse'
    }
];

export type IconType = {
    img: string;
    altText: string;
    width?: number;
}

export function randomizeIcons() {
    let randomizedIcons = images;
    const sizes = [ 60, 80, 100 ];
    for (let i = randomizedIcons.length - 1; i >= 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = randomizedIcons[i];
        randomizedIcons[i] = randomizedIcons[j];
        randomizedIcons[i].width = sizes[Math.floor(Math.random() * sizes.length)];
        randomizedIcons[j] = temp;
    }
    return randomizedIcons;
}

export function randomizeIconsOnCards(icons: number[]) {
    let randomizedIcons = icons;
    for (let i = randomizedIcons.length - 1; i >= 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = randomizedIcons[i];
        randomizedIcons[i] = randomizedIcons[j];
        randomizedIcons[j] = temp;
    }
    return randomizedIcons;
}